import { allFailedContentValues } from '@api/api/conversations-schema';
import { TFunction } from 'i18next';

export const getErrorText = (
  t: TFunction,
  content: string | undefined
): string => {
  const value = content ?? '';
  const isKnownError = allFailedContentValues.some(v => v === value);

  return isKnownError
    ? t('alerts:alfredCard.errorText', { context: value })
    : t('alerts:alfredCard.errorText');
};
